/**
 * Get rank of the given slide depending of the current slide real index
 * The rank can be a negative or positive Int
 * @returns [Int] Rank
 */
export const getSlideRank = ({
	currentSlideIndex,
	firstVisibleSlideIndex,
	x,
	positionIndex,
	items,
}) => {
	return (
		currentSlideIndex -
		(x < 0 ? items.length : 0) +
		positionIndex -
		firstVisibleSlideIndex
	);
};
